
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 691.2 547.96"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_2-2","data-name":"Layer 2"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M596.92 491.57a3.39 3.39 0 01-3.39 3.39H56.39a3.39 3.39 0 01-3.39-3.39V300.48a3.39 3.39 0 013.39-3.39H308a14.29 14.29 0 0012-6.56l1-1.57 14.69-22.83a14.3 14.3 0 00-12-22H56.39A56.39 56.39 0 000 300.48v191.09A56.39 56.39 0 0056.39 548h537.14a56.39 56.39 0 0056.39-56.39V300.48a56.2 56.2 0 00-3.29-19c-3.92-10.9-18.7-12.49-25-2.75L602 309.34a31.73 31.73 0 00-5 17.16z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M123.24 379.14v27a13 13 0 0013 13h181.87a8.54 8.54 0 008.33-10.28c-.46-2.28-.81-4.6-1.06-6.94l-3-28.15a8.51 8.51 0 00-8.47-7.63H136.24a13 13 0 00-13 13zM662.64 43.05l-51.73-33.2a61.69 61.69 0 00-85.44 18.65L346.53 306.62l9.68 92.06a44.52 44.52 0 0058.55 37.57l87.72-29.57 178.93-278.12a61.92 61.92 0 00-18.77-85.51zm-91.38 14.78a7.35 7.35 0 016.3-3.43 7.48 7.48 0 014.08 1.2l51.74 33.19a7.68 7.68 0 012.36 10.51l-22.1 34.45-64.53-41.4zm13 121.59L467 361.29l-58.07 19.65-6.34-61L519.72 138z"}})])])])
          )
        }
      }
    